export const SITE_VERSION = "1.4.0";
export const LAST_UPDATE = "6 juin 2026";
